import { api } from '@/api';
import { EvaluationParameterDto, TrackItTaskWorkResultDto } from '@/api/generator';
import { ref } from 'vue';
import {
  buildTrackItTaskResultForEvaluation,
  TrackItManualValue,
} from './trackItTaskResultForEvaluation';

export function useTrackItManualValue() {
  const submitting = ref(false);

  async function submitManualValue(
    result: TrackItTaskWorkResultDto,
    evaluation: EvaluationParameterDto,
    value: TrackItManualValue | null,
    workStepId: string,
    jobOccurrenceId: string,
  ): Promise<TrackItTaskWorkResultDto | undefined> {
    if (result.trackItMeasurementId === undefined) {
      return undefined;
    }

    submitting.value = true;

    const { result: response, success } =
      await api.trackItImportApi.importTrackItMeasurementForWorkStep({
        importTrackItMeasurementForWorkStepDto: {
          resultId: result.id,
          trackItMeasurementId: result.trackItMeasurementId,
          jobOccurrenceId,
          workStepId,
          additionalResults: [buildTrackItTaskResultForEvaluation(evaluation, value)],
        },
      });

    submitting.value = false;

    return success ? response : undefined;
  }

  return { submitting, submitManualValue };
}
